export const shouldLoad = () => document.querySelector('.klt-accordion') !== undefined;
